import type { AppRouteRecordRaw } from 'common/router/type'
import { getDeviceType } from 'common/utils/system'
import { useTimer } from '@/hooks/useTimer'
import useOrderStore from '@/store/order'
import type { IndiaQr } from '@/types/indiaQr'
import { getQR } from '@/api/order'
import { reactive, ref } from 'vue'
import { indiaQrBindUtr } from '@/api/indiaQr'
import { modalAlert } from '@/utils/modal'
import { env } from 'common/utils/env'

export const route: AppRouteRecordRaw = {
  path: `/appqr`,
  component: () => getDeviceType() === 'mobile' ? import('./mobile.vue') : import('./pc.vue'),
}

export const usePageHook = () => {
  const orderStore = useOrderStore()
  /** 获取银行logo */
  const getBankLogo = (name: string) => {
    if (env.isUseVite) {
      return require(`../../../assets/bank/${name}.png`)
    } else {
      return require(`../../../assets/bank/${name}.png`)
    }
  }
  const bankList = [
    getBankLogo(`paytm`),
    getBankLogo(`phonePe`),
    getBankLogo(`gPay1`),
    getBankLogo(`bhim`),
    getBankLogo(`india`),
    getBankLogo(`indiaM`),
    getBankLogo(`indiaF`),
  ]

  const qrCode = ref<string>()
  /** 获取二维码 */
  const getQrCode = () => {
    getQR().then(res => {
      qrCode.value = `data:image/png;base64,${res.qrcode}`
    })
  }

  const formState = reactive({
    utr: '',
  } as IndiaQr)
  const onUtrInput = () => {
    formState.utr = formState.utr.replace(/[^\d]/g, '')
  }
  /** 提交UTUR */
  const submitUtr = () => {
    if (formState.utr.length !== 12) {
      modalAlert({
        type: 'warning',
        content: `Important reminder: After completingthe UPI transaction, please backfill RefNo ./UTR No./Google Pay : UPI transaction ID/Freecharge: TransactionID (12 digits). lf you do not backfill UTR 100% of the deposit transaction will fail.Please be sure to backfill! I know and continue to pay.`,
      })
    } else {
      indiaQrBindUtr(formState).then(() => {
        modalAlert({
          type: 'success',
          content: `Submitted successfully.`,
        })
        endExpiredTimer()
        startLoopTimer(orderStore.getInfo)
      }
      )
    }
  }

  const { orderInfo, startLoopTimer, endExpiredTimer } = useTimer()

  const init = () => {
    startLoopTimer(orderStore.getInfo)
    if (getDeviceType() === 'pc') {
      getQrCode()
    }
  }

  return {
    getBankLogo,
    orderInfo,
    init,
    bankList,
    qrCode,
    formState,
    onUtrInput,
    submitUtr,
  }
}